import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Button, Grid, Typography, Radio, RadioGroup, TextField, FormControlLabel } from '@mui/material';
import useStyles from './styles';
import { uploadCampaignFileCSV } from '../../../store/admin/file-type-configuration/actions';
import ProgressBar from '../../progress-bar';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';
import PowerBiIcon from '../../../assets/icons/power-bi-icon';
import FileDrop from '../../file-drop';

const CampaignUploader = () => {
  const powerBiDashboardURL =
    'https://app.powerbi.com/groups/me/apps/bacf7bff-f8cd-4409-8ef0-06d0873c5bb7';
  const fileUpperLimit = 250 * 1024 ** 2; // 250MB
  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [fileName, setFileName] = useState<string>('');
  const [campaignFile, setCampaignFile] = useState<any>();
  const [uploadInProgress, setUploadInProgress] = useState<boolean>(false);
  const [tabValue, setTabValue] = useState<string>('FOTA');
  const classes = useStyles();
  const dispatch = useDispatch();
  const uploadFile = () => {
    setUploadProgress(0);
    setUploadInProgress(true);
    dispatch(uploadCampaignFileCSV(campaignFile, setUploadProgress, setUploadInProgress, tabValue));
    setCampaignFile('');
  };
  const rejectFile = (file: any) => {
    let errorMessage = 'Invalid File Type';
    if (file.size > fileUpperLimit) {
      errorMessage = 'File Not Allowed To Exceed 1 GB';
    }
    dispatch(
      enqueueSnackbarAction({
        message: errorMessage,
        options: {
          variant: 'error',
        },
      }),
    );
  };
  const endline = `\r\n`
  const templateText = tabValue.includes('FOTA') ? `deviceId,firmwareFileName,partNumber,region,campaign${endline}000A752BF9A0e4acd3ef71c899eacb,2021.2.2_PL243_6206924-00.fl2,6206924-00,US,PL243 HELIOS CAMPAIGN - FEB. 10TH${endline}`
    : `deviceId,firmwareFileName,campaign${endline}000A752BF9A0e4acd3ef71c899eacb,2021.2.2_PL243_6206924-00.fl2,PL243 HELIOS CAMPAIGN - FEB. 10TH${endline}`;
  const downloadTemplate = `data:text/plain;charset=utf-8, ${encodeURIComponent(templateText)}`;
  const handleChange = (event: any) => {
    const updateValue = event.target.value;
    setTabValue(updateValue);
    setCampaignFile('');
  }
  
  return (
    <Grid container direction="row" alignItems="stretch" className={campaignFile ? classes.campaignContainerWidth : classes.campaignContainer}>
      {!uploadInProgress && (
        <>
          <Box>
            <RadioGroup
              row
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={tabValue}
              onChange={handleChange}
            >
              <FormControlLabel value="FOTA" control={<Radio />} label="Flash" />
              <FormControlLabel value="modemFlash" control={<Radio />} label="Modem Flash" />
            </RadioGroup>
          </Box>

          <Box className={classes.dropZoneContainer}>
            <FileDrop
              processAcceptedFile={(file: any) => {
                setFileName(file.name);
                setCampaignFile(file);
              }}
              acceptedFileTypes={['text/csv', '.csv']}
              customDropMessage="Drop Campaign File Here"
              maxFileSize={fileUpperLimit}
              handleFileRejection={rejectFile}
            />
          </Box>
          <Grid xs={12}>
            {tabValue.includes('FOTA') &&
              <a href={powerBiDashboardURL} target="_blank" rel="noreferrer">
                <PowerBiIcon className={classes.powerBi} />
                <span className={classes.biContainer}>Power BI Dashboard</span>
              </a>
            }
            <a href={downloadTemplate} download="template.csv" className={classes.download}>
              Download Template
            </a>
          </Grid>
          <Grid xs={12} className={classes.uploadContainer}>
            {campaignFile && (
              <>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={uploadFile}
                  disabled={uploadInProgress || fileName === ''}
                >
                  Upload
                </Button>
                <Typography>{campaignFile.name}</Typography>
              </>
            )}
          </Grid>
        </>
      )}
      {uploadInProgress && (
        <Grid xs={12}>
          <ProgressBar percentUpload={uploadProgress} />
        </Grid>
      )}
    </Grid>
  );
};
export default CampaignUploader;
